export default __webpack_public_path__ + "static/media/clock.e0dedea1.svg";